import { useContext } from "react";
import { ThemeContext, GipContext } from "state";

export default function TitleBar() {
  const themeContext = useContext(ThemeContext);
  const { isMobile } = useContext(GipContext);
  const logoPath = isMobile ? './assets/icon/cefic-logowhite-mobile.svg' : './assets/icon/cefic-logowhite.svg';
  return (
    <div className="title-bar px-8 flex items-center justify-center py-2 relative h-16 bg-gradient-to-r from-startGradient to-endGradient">
      <div className="logo absolute inset-y-0 left-0 h-16">
        <img
          src={`${logoPath}`}
          alt="cefic logo"
          className="w-auto h-10 mt-3 ml-3"
        />
      </div>
      <div className="title text-center text-white text-lg max-w-[13rem] sm:max-w-full leading-6 sm:text-2xl font-noto">
        <h1>{themeContext.title}</h1>
      </div>
    </div>
  );
}
